import { getFullAddressAction } from 'redux/actions/googleMapsActions';
import { generateRequestWithDataReducer } from 'redux/utils/requestWithData';

export default generateRequestWithDataReducer(getFullAddressAction);
